import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import useDocDownload from "../app/hooks/useDocDownload";
import { deleteReceivedDocument, getDocuments, getEsignDocuments, getReceivedDocDeleteStatus, getReqDocuments, getSignedDocumentData, loadDocuments, loadEsignDocuments, loadReqDocuments, loadSignedDocument, receviedDocDeleted, signedDocumentReceived, updateReceivedDocStatus } from "../app/store/documents";
import { getPurchaseOrderDoc, getPurchaseOrders, loadPurchaseOrderDoc, loadPurchaseOrders, purchaseOrderDocReceived } from "../app/store/purchaseOrder";
import { getAlert, getConfirmAlert, getConfirmAlertWithAuth } from "../services/appAlerts";
import moment from "moment";

const ReceivedDocuments = ({
    item, workflowTask
}) => {

    const [pOrders, setPOrders] = useState([]);
    const [reqDocs, setReqDocs] = useState([]);
    const [appDocuments, setAppDocuments] = useState([]);
    const [esignDocs, setEsignDocs] = useState([]);
    const [selectedSignedDoc, setSelectedSignedDoc] = useState(null);
    const [signLoading, setSignLoading] = useState(false);
    const [deleteType, setDeleteType] = useState("");

    const documentsSelector = useSelector(getDocuments);
    const purchaseOrdersSelector = useSelector(getPurchaseOrders);
    const reqDocumentsSelector = useSelector(getReqDocuments);
    const purchaseOrderDocSelector = useSelector(getPurchaseOrderDoc);
    const esignDocumentsSelector = useSelector(getEsignDocuments);
    const signedDocumentDataSelector = useSelector(getSignedDocumentData);
    const receivedDocDeleteStatusSelector = useSelector(getReceivedDocDeleteStatus);


    const [handleDownloadFile] = useDocDownload();

    const dispatch = useDispatch();

    useEffect(() => {

    }, [])

    useEffect(() => {
        if (workflowTask) {
            setReqDocs([]);
            setPOrders([]);
            setAppDocuments([]);
            setEsignDocs([]);
            dispatch(loadDocuments(workflowTask.ciid));
            dispatch(loadReqDocuments(workflowTask.ciid));
            dispatch(loadPurchaseOrders(item.id));
            dispatch(loadEsignDocuments(item?.id));
        }
    }, [workflowTask])

    useEffect(() => {
        setEsignDocs(esignDocumentsSelector);
    }, [esignDocumentsSelector])

    useEffect(() => {
        setPOrders(purchaseOrdersSelector);
    }, [purchaseOrdersSelector]);

    useEffect(() => {
        setReqDocs(reqDocumentsSelector);
    }, [reqDocumentsSelector])

    useEffect(() => {
        setAppDocuments(documentsSelector);
    }, [documentsSelector]);

    const handleDocStatusChange = (docId, status, type) => {
        dispatch(updateReceivedDocStatus(docId, status, type));
    }

    const handleDeleteFile = async (docId, type) => {
        const confirmDelete = await getConfirmAlertWithAuth(
            "",
            "Are you sure you want to delete this document?",
            "warning"
        );

        if (confirmDelete.isConfirmed) {
            dispatch(deleteReceivedDocument(docId, type));
            setDeleteType(type);
        }
    };


    useEffect(() => {
        if (receivedDocDeleteStatusSelector) {
            getAlert("", "Document deleted successfully", "success");
            setDeleteType("");
            dispatch(receviedDocDeleted(null));
            // Refresh document lists after deletion
            if (deleteType === "doc") {
                dispatch(loadDocuments(workflowTask.ciid));
            } else if (deleteType === "req") {
                dispatch(loadReqDocuments(workflowTask.ciid));
            } else if (deleteType === "po") {
                dispatch(loadPurchaseOrders(item.id));
            } else if (deleteType === "esign") {
                dispatch(loadEsignDocuments(item?.id));
            }
        }
    }, [receivedDocDeleteStatusSelector]);

    const getReqRefDocs = (item) => {
        if (item.refDocId > 0) {
            const findDocs = appDocuments.filter(x => x.uploadId === item.refDocId && x.deleteFlag !== true);
            if (findDocs.length > 0) {
                return <>
                    {findDocs.map(doc =>
                        <td className="text-wrap">
                            {/* <button
                                className="btn btn-link btn-sm p-0"
                                title="Download Document"
                                onClick={() => handleDownloadFile(doc)}
                            >
                                {doc.docName}
                            </button>
                            <br /> */}
                            {item.documnetName}
                            <br />
                            {getReqUploadedDocs(item, "req")}
                        </td>
                    )}
                </>
            }
        }

        return <td>
            {item.documnetName}
            <br />
            {getReqUploadedDocs(item, "req")}
        </td>
    }

    const getReqUploadedDocs = (item, type) => {
        const achDocs = appDocuments.filter(
            (x) => x.updType === `req_${!item.id ? item.docId : item.id}` && x.deleteFlag !== true
        );

        if (achDocs.length > 0) {
            const doc = achDocs[0];
            return <>
                <button
                    className="btn btn-link btn-sm p-0"
                    title="Download Document"
                    onClick={() => handleDownloadFile(doc)
                    }
                >
                    {doc.docName}
                </button>
            </>
        }

        return <></>;
    }

    const getReqUploadedNotes = (item) => {
        const achDocs = appDocuments.filter(
            (x) => x.updType === `req_${!item.id ? item.docId : item.id}` && x.deleteFlag !== true
        );

        if (achDocs.length > 0) {
            const doc = achDocs[0];
            return <>
                {doc.remarks}
            </>
        }

        return <></>

    }

    const getReqUploadedSize = (item) => {
        const achDocs = appDocuments.filter(
            (x) => x.updType === `req_${!item.id ? item.docId : item.id}`
        );
        if (achDocs.length > 0) {
            const doc = achDocs[0];
            return <>
                {doc.docSize}
            </>
        }

        return <></>

    }

    const getReqUploadedStatus = (item) => {
        const achDocs = appDocuments.filter(
            (x) => x.updType === `req_${!item.id ? item.docId : item.id}` && x.deleteFlag !== true
        );
        if (achDocs.length > 0) {
            const doc = achDocs[0];
            return <>
                <td className="p-0 m-0">
                    <button
                        className="btn btn-sm btn-link text-danger"
                        title="Delete File"
                        onClick={() => handleDeleteFile(doc.docId, "doc")}
                    >
                        <i className="fa fa-trash"></i>
                    </button>
                </td>
                {/* Received From  {doc.performerId === item?.performerid
                    ? "Candidate"
                    : item?.registrationType === "candidate"
                        && item?.subcontractor?.fuid > 0
                        ? "Subcontractor"
                        : item?.partnerType} */}
                <td>
                    Received
                </td>
            </>
        }

        return <> <td className="p-0 m-0">
            <button
                className="btn btn-sm btn-link text-danger"
                title="Delete File"
                onClick={() => handleDeleteFile(item.id, "req")}
            >
                <i className="fa fa-trash"></i>
            </button>
        </td><td>Sent</td></>

    }

    const handleDownloadPoFile = async (item, type) => {
        dispatch(loadPurchaseOrderDoc(item.id, type));
    };

    useEffect(() => {
        console.log("purchaseOrderDocSelector", purchaseOrderDocSelector);
        if (purchaseOrderDocSelector?.uploadUrl === null) {
            getAlert("", "Document Not Found", "error");
            dispatch(purchaseOrderDocReceived(null));
        } else if (purchaseOrderDocSelector?.uploadUrl) {
            // const url = window.URL.createObjectURL(purchaseOrderDocSelector);
            // const link = document.createElement("a");
            // link.href = url;
            // link.target = "_blank";
            // document.body.appendChild(link);
            // link.click();
            // link.parentNode.removeChild(link);
            window.open(purchaseOrderDocSelector?.uploadUrl, "_blank");
            dispatch(purchaseOrderDocReceived(null));
        }
    }, [purchaseOrderDocSelector]);

    const handleDownloadEsignedFile = async (item, type) => {
        setSelectedSignedDoc(item);
        setSignLoading(true);
        dispatch(loadSignedDocument(item.id, type));
    }

    useEffect(() => {
        if (signedDocumentDataSelector && selectedSignedDoc) {
            // const url = window.URL.createObjectURL(signedDocumentDataSelector);
            // const link = document.createElement("a");
            // link.href = url;
            // link.target = "_blank";

            // if (selectedSignedDoc?.docName)
            //     link.setAttribute("download", selectedSignedDoc.docName);
            // else if (selectedSignedDoc?.documentName)
            //     link.setAttribute("download", selectedSignedDoc.documentName);
            // else
            //     link.setAttribute("download", "ipcs_document");

            // document.body.appendChild(link);
            // link.click();
            // link.parentNode.removeChild(link);
            window.open(signedDocumentDataSelector?.uploadUrl, "_blank");
            setSelectedSignedDoc(null);
            setSignLoading(false);
            dispatch(signedDocumentReceived(null));
        }
    }, [signedDocumentDataSelector])

    //console.log({ appDocuments, pOrders, reqDocs, item, esignDocs });
    // Step 1: Merge and normalize dates with moment
    const mergedDocs = [
        ...appDocuments
            .filter(
                (x) =>
                    x.uploadType !== "agency" &&
                    x.uploadType !== "msp" &&
                    x.uploadType !== "Invoice" &&
                    x.remarks !== "Time Sheet" &&
                    x.uploadType !== "Messaging" &&
                    x.uploadType !== "reporting" &&
                    !x.uploadType?.includes("req_") &&
                    !x.uploadType?.includes("ach_") &&
                    !x.uploadType?.includes("insurance_") &&
                    x.deleteFlag !== true &&
                    x.docModifiedName !== "esign" &&
                    (x.sentStatus === true || item?.performerid === x?.uploaderId || item?.id === x?.uploaderId)
                //x.uploadType !== "reporting" &&
                //&& (item?.performerid === x?.uploaderId || item?.id === x?.uploaderId)
            )
            .map((d) => ({
                ...d,
                type: "app",
                date: moment(d.dateTime) // use moment
            })),

        ...pOrders
            .filter((x) => x.sendStatus === true)
            .map((p) => ({
                ...p,
                poType: p.type,
                type: "po",
                date: moment(p.addedDateTime) // use moment
            })),

        ...reqDocs
            .filter((f) => f.sendStatus === true)
            .map((f) => ({
                ...f,
                type: "req",
                date: moment(f.addedDateTime) // use moment
            })),

        ...esignDocs
            .filter((f) => f.signedStatus === "1")
            .map((f) => ({
                ...f,
                type: "esign",
                date: moment(f.createdDateTime) // use moment
            }))
    ];

    // Step 2: Sort descending
    const sortedDocs = mergedDocs.sort((a, b) => b.date - a.date);

    // Step 3: Row renderer (handles all types)
    const renderRow = (doc) => {
        return (
            <>
                {/* Common Date Column */}
                <td>
                    <Moment format="MMM Do YYYY">{doc.date}</Moment>
                    <br />
                    <Moment format="h:mm a">{doc.date}</Moment>
                </td>

                {doc.type === "app" && (
                    <>
                        <td className="text-wrap">
                            <button
                                className="btn btn-sm btn-link pl-0 text-wrap text-left"
                                title="Download File"
                                onClick={() => handleDownloadFile(doc)}
                            >
                                {doc.docName}
                            </button>
                        </td>
                        <td className="p-0 m-0">
                            <button
                                className="btn btn-sm btn-link text-danger"
                                title="Delete File"
                                onClick={() => handleDeleteFile(doc.docId, "doc")}
                            >
                                <i className="fa fa-trash"></i>
                            </button>
                        </td>
                        {/* <td>{(doc.uploaderType === "WP" || doc.uploaderType=== "Super Admin") ? "Reviewer" : doc.uploaderType}</td> */}
                        <td>{(doc.uploaderType === "WP" || doc.uploaderType === "Super Admin") ? "Sent" : <>Received</>}</td>
                        <td>{doc.docSize}</td>
                        <td className="text-wrap">{doc.remarks}</td>
                        <td>
                            <select
                                className="form-control form-control-sm"
                                value={doc.docStatus}
                                onChange={(e) =>
                                    handleDocStatusChange(doc.docId, e.target.value, "doc")
                                }
                            >
                                <option value="">Select Status</option>
                                <option value="1">Approved</option>
                                <option value="0">Not Approved</option>
                            </select>
                        </td>
                    </>
                )}

                {doc.type === "po" && (
                    <>
                        <td className="text-wrap">
                            PO - {doc.poType === "subcontractor" && "Subcontractor"}
                            {doc.poType === "recruiter" && "Recruiter"}
                            <br />
                            {doc.partnerSign && <button
                                className="btn btn-sm btn-link pl-0 text-wrap text-left"
                                onClick={() => handleDownloadPoFile(doc, "partner")}
                            >
                                {doc.ipcsPoName}
                            </button>}

                        </td>
                        <td className="p-0 m-0">

                            <button
                                className="btn btn-sm btn-link text-danger"
                                title="Delete File"
                                onClick={() => handleDeleteFile(doc.id, "po")}
                            >
                                <i className="fa fa-trash"></i>
                            </button>
                        </td>
                        <td>
                            {doc.partnerSign
                                ? "Received"
                                : "Sent"}
                        </td>
                        {/* <td>Reviewer</td> */}
                        <td></td>
                        <td className="text-wrap">{doc.notes}</td>
                        <td style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>
                            <select
                                className="form-control form-control-sm"
                                value={doc.status}
                                onChange={(e) =>
                                    handleDocStatusChange(doc.id, e.target.value, "po")
                                }
                            >
                                <option value="">Select Status</option>
                                <option value="1">Approved</option>
                                <option value="0">Not Approved</option>
                            </select>
                        </td>
                    </>
                )}

                {doc.type === "req" && (
                    <>
                        {getReqRefDocs(doc)}
                        {/* <td>
                            {doc.performerId === item?.performerid
                                ? "Candidate"
                                : item?.registrationType === "candidate" 
                                && item?.subcontractor?.fuid > 0 
                                ? "Subcontractor" 
                                : item?.partnerType}
                        </td> */}
                        {getReqUploadedStatus(doc)}
                        <td>{getReqUploadedSize(doc)}</td>
                        <td className="text-wrap">{getReqUploadedNotes(doc)}</td>
                        <td style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>
                            <select
                                className="form-control form-control-sm"
                                value={doc.status}
                                onChange={(e) =>
                                    handleDocStatusChange(doc.id, e.target.value, "req")
                                }
                                style={{ minWidth: '100%', whiteSpace: 'nowrap' }}
                            >
                                <option value="">Select Status</option>
                                <option value="1">Approved</option>
                                <option value="0">Not Approved</option>
                            </select>
                        </td>
                    </>
                )}
                {doc.type === "esign" && (
                    <>
                        <td className="text-wrap">
                            <button
                                className="btn btn-sm btn-link pl-0 text-wrap text-left"
                                disabled={signLoading && selectedSignedDoc?.id === doc.id}
                                onClick={() => handleDownloadEsignedFile(doc, "1")}
                            >
                                {doc.documentName}
                            </button>

                        </td>
                        <td className="p-0 m-0">
                            <button
                                className="btn btn-sm btn-link text-danger"
                                title="Delete File"
                                onClick={() => handleDeleteFile(doc.id, "esign")}
                            >
                                <i className="fa fa-trash"></i>
                            </button>
                        </td>
                        <td>Received</td>
                        <td>{doc.docSize}</td>
                        <td></td>
                        <td style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>
                            <select
                                className="form-control form-control-sm"
                                value={doc.signedDocStatus}
                                onChange={(e) =>
                                    handleDocStatusChange(doc.id, e.target.value, "esign")
                                }
                                style={{ minWidth: '100%', whiteSpace: 'nowrap' }}
                            >
                                <option value="">Select Status</option>
                                <option value="1">Approved</option>
                                <option value="0">Not Approved</option>
                            </select>
                        </td>
                    </>
                )}
            </>
        );
    };

    return (
        <table className="table table-striped align-items-center table-flush border">
            <thead className="thead-light-green">
                <tr>
                    <th>Date and Time</th>
                    <th>Document</th>
                    <th></th>
                    {/* <th>Entity</th> */}
                    <th>Status</th>
                    <th>Size</th>
                    <th>Notes</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {sortedDocs.map((doc, key) => (
                    <tr key={key}>{renderRow(doc)}</tr>
                ))}
            </tbody>
        </table>
    );
};

export default ReceivedDocuments;
